import React from "react";
import './news.css'

export default function News({ }) {
    return (<React.Fragment>
        <h1>NEWS</h1>
        <article className="news">
            <hr />
            <h3>4/21/2024</h3>
            <h3>CONGRATULATIONS MARY MURDOCK MEYER!!!</h3>
            <p>Mary Meyer, Chief Executive of the Timpanogos Nation, has just been made "Global Women Peace Ambassador" for the Women's Federation For World Peace USA.</p>
        </article>
        <article className="news">
            <hr />
            <h3>08/10/2021</h3>
            <h3>The Timpanogos Make A Rare Public Appearance</h3>
            <p>Brigham Young University ecology professor Ben Abbott invited Chief Executive Mary Meyer of the Timpanogos Nation to speak at the Utah Lake symposium that was held at Utah Valley University on June 5th. Utah Lake has been in decline from years of abuse and neglect going back decades. Toxic algae blooms, and invasive fish such as carp have led to developers recommending the lake be dredged and islands built in an effort to accommodate Utah Valley's burgeoning population growth. Whereas ecologists and scientists disagree with such plans saying it would drastically change the ecology of the lake.</p>
        </article>
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
    </React.Fragment>)
}
